import { graphql } from '~/lib/graphql'

export const PlanRestaurant = graphql(`
  fragment PlanRestaurant on Plan {
    restaurant {
      name
      paypayAvailable
      pointAvailable
      cardPaymentAvailable
      notes
      noncancelableDays
    }
  }
`)
